export default __webpack_public_path__ + "static/media/SigmaMain.90b2c83b.jpeg";